import { parsePhoneNumber } from "../../../vendor/react-phone-number-input/min/index.js";
import parseIncompletePhoneNumber from "../../../vendor/libphonenumber-js/es6/parseIncompletePhoneNumber.js";
const parsePossiblePhoneNumber = (number, country) => {
  const plusIndex = (number ?? "").lastIndexOf("+");
  plusIndex && plusIndex !== -1 && (number = number == null ? void 0 : number.slice(plusIndex));
  let parsed = parsePhoneNumber(
    number ?? "",
    country
  ) || {
    number: "",
    country: null
  };
  if (!parsed.number) {
    parsed.number = parseIncompletePhoneNumber(number ?? "");
    const val = parsePhoneNumber(parsed.number, country);
    val && (parsed = val);
  }
  return {
    parsedValue: parsed.number,
    parsedCountry: parsed.country
  };
};
function forceSetInputValue(input, value) {
  if (!input) return;
  input.blur(), input.value = value, input.focus();
  const event = new InputEvent("input", {
    bubbles: !0,
    data: "FORCE_UPDATE"
  });
  input.dispatchEvent(event);
}
export {
  forceSetInputValue,
  parsePossiblePhoneNumber
};
//# sourceMappingURL=utils.js.map
